import { RemoteParticipant } from "twilio-video";
import { convertParticipantToRoomParticipant } from "./convertParticipantToRoomParticipant";

export const getRoomParticipantsArray = (participants: RemoteParticipant[]) => {
  return participants.map((participant) =>
    convertParticipantToRoomParticipant(participant),
  );
};
